import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { Box, Button, IconButton, Typography } from "@mui/material";
import { NavigateAction } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import CustomSelect from "../../../../../../components/CustomSelect";
import Flex from "../../../../../../components/Flex";
import { ViewType } from "../../../scheduling/SchedulingLayout";
interface ToolBarProps {
  label: string;
  onNavigate: (navigate: NavigateAction) => void;
  view?: ViewType;
  handleChangeView?: (view: ViewType) => void;
}

const ToolBar = (props: ToolBarProps) => {
  return (
    <Flex justifyContent={"space-between"} mb={2}>
      <Flex alignItems={"center"} justifyContent={"left"} gap={"10px"}>
        <Button variant="outlined" onClick={() => props.onNavigate("TODAY")}>
          Today
        </Button>
        <IconButton
          sx={{ color: "#1A1A1ACC" }}
          onClick={() => props.onNavigate("PREV")}
        >
          <ChevronLeft color="primary" />
        </IconButton>
        <IconButton
          sx={{
            color: "#1A1A1ACC",
          }}
          onClick={() => props.onNavigate("NEXT")}
        >
          <ChevronRight color="primary" />
        </IconButton>
        <Typography
          sx={{
            color: "primary.main",
            letterSpacing: "-0.17px !important",
            fontSize: "1rem",
            fontWeight: "bold",
          }}
          variant="body2"
        >
          {props.label}
        </Typography>
      </Flex>
      <Flex alignItems={"center"} justifyContent={"center"} gap={"20px"}>
        <Box width={"120px"}>
          <CustomSelect
            disableSortOptions
            clearable={false}
            options={[
              { value: "day", label: "Day" },
              { value: "week", label: "Week" },
              { value: "month", label: "Month" },
            ]}
            value={props.view}
            onChange={(val) => {
              props?.handleChangeView?.(val as ViewType);
            }}
          />
        </Box>
      </Flex>
    </Flex>
  );
};

export default ToolBar;
